// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: at most `max` tasks at a time; the rest wait their turn in order. For fan-outs such as
// loading every ClickUp list's statuses, which the API forwards to ClickUp (four at a time per
// token there anyway) and which used to arrive at the API all at once.

export class ConcurrencyGate {
	private active = 0;
	private waiting: Array<() => void> = [];

	constructor(private readonly max: number) {}

	async run<T>(task: () => Promise<T>): Promise<T> {
		if (this.active >= this.max) await new Promise<void>((resolve) => this.waiting.push(resolve));
		this.active += 1;
		try {
			return await task();
		} finally {
			this.active -= 1;
			this.waiting.shift()?.();
		}
	}
}
